const Intro = () => (
  <div className="text-j-dark-400 text-sm my-0">
    For our students’ safety per the Children’s Online Privacy Protection Rule
    (COPPA), we require payment info. Read more below.
  </div>
);

export default Intro;
